module.exports = "<div *ngIf=\"NewsList.length > 0\">\n    <h3 class=\"title-home\"><b>{{HomeAd.News}}</b></h3>\n    <div class=\"news-container\">\n        <div class=\"card-columns\">\n            <div  *ngFor=\"let item of NewsList\">\n                <app-tnnewslist-item [newsData]=\"item\"></app-tnnewslist-item>\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/tnnewslist.component.html
// module id = ../../../../../src/app/themes/default/html/tnnewslist.component.html
// module chunks = 1